// extracted by mini-css-extract-plugin
module.exports = {"desktop":"Menu_desktop__3wNHX","mobile":"Menu_mobile__asRMP"};